import { render, staticRenderFns } from "./StudyDepartmentCallIn.vue?vue&type=template&id=22b6bdfc&scoped=true&"
import script from "./StudyDepartmentCallIn.vue?vue&type=script&lang=js&"
export * from "./StudyDepartmentCallIn.vue?vue&type=script&lang=js&"
import style0 from "./StudyDepartmentCallIn.vue?vue&type=style&index=0&id=22b6bdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6bdfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
